import React from "react";
import Typography from '@mui/material/Typography';
import './About.scss';
import Achievements from "../Achievements/Achievements.jsx";
import Platforms from "../Platforms/Platforms";
import AboutMe from "../AboutMe/AboutMe";

const About = () => {
    return (
        <div id="about">
            <div className="container">

                <Typography variant="h3" gutterBottom component="div" className="text-center main-heading">
                    Anshika Agrawal
                </Typography>
                <Typography variant="h6" gutterBottom component="div" className="text-center mini-heading">
                    Mern Stack Developer and Coding Enthusiast
                </Typography>
                <Typography variant="h6" gutterBottom component="div" className="text-center sub-heading">
                    Former SDE Intern - <b>Amazon</b>, <b>Goldman Sachs</b>
                </Typography>


                <AboutMe />
                <Platforms />

                <Achievements />

            </div>
        </div>
    )
}

export default About;